import { createSlice } from "@reduxjs/toolkit";
import {
    getProyectosKpisData,
    getProyectosEvolucionData,
    getProyectosMediaEvolucionData,
    getProyectosPorTipoData,
    getProyectosPorPaisData,
    getProyectosTareasData,
    getProyectosParcialData,
    getProyectosRendimientoData
} from './thunk';

const initialState = {
    kpis: null,
    evolucion: null,
    mediaEvolucion: null,
    porTipo: null,
    porPais: null,
    tareas: null,
    parcial: null,
    rendimiento: null,
    loading: { kpis: false, evolucion: false, mediaEvolucion: false, tipo: false, pais: false, tareas: false, parcial: false, rendimiento: false },
    error: null,
};

const DashboardProyectosSlice = createSlice({
    name: 'DashboardProyectos',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getProyectosKpisData.pending, (s) => { s.loading.kpis = true; })
            .addCase(getProyectosKpisData.fulfilled, (s, a) => { s.loading.kpis = false; s.kpis = a.payload; })
            .addCase(getProyectosKpisData.rejected, (s, a) => { s.loading.kpis = false; s.error = a.error.message; })
            .addCase(getProyectosEvolucionData.pending, (s) => { s.loading.evolucion = true; })
            .addCase(getProyectosEvolucionData.fulfilled, (s, a) => { s.loading.evolucion = false; s.evolucion = a.payload; })
            .addCase(getProyectosEvolucionData.rejected, (s, a) => { s.loading.evolucion = false; })
            .addCase(getProyectosMediaEvolucionData.pending, (s) => { s.loading.mediaEvolucion = true; })
            .addCase(getProyectosMediaEvolucionData.fulfilled, (s, a) => { s.loading.mediaEvolucion = false; s.mediaEvolucion = a.payload; })
            .addCase(getProyectosMediaEvolucionData.rejected, (s, a) => { s.loading.mediaEvolucion = false; })
            .addCase(getProyectosPorTipoData.pending, (s) => { s.loading.tipo = true; })
            .addCase(getProyectosPorTipoData.fulfilled, (s, a) => { s.loading.tipo = false; s.porTipo = a.payload; })
            .addCase(getProyectosPorTipoData.rejected, (s, a) => { s.loading.tipo = false; })
            .addCase(getProyectosPorPaisData.pending, (s) => { s.loading.pais = true; })
            .addCase(getProyectosPorPaisData.fulfilled, (s, a) => { s.loading.pais = false; s.porPais = a.payload; })
            .addCase(getProyectosPorPaisData.rejected, (s, a) => { s.loading.pais = false; })
            .addCase(getProyectosTareasData.pending, (s) => { s.loading.tareas = true; })
            .addCase(getProyectosTareasData.fulfilled, (s, a) => { s.loading.tareas = false; s.tareas = a.payload; })
            .addCase(getProyectosTareasData.rejected, (s, a) => { s.loading.tareas = false; })
            .addCase(getProyectosParcialData.pending, (s) => { s.loading.parcial = true; })
            .addCase(getProyectosParcialData.fulfilled, (s, a) => { s.loading.parcial = false; s.parcial = a.payload; })
            .addCase(getProyectosParcialData.rejected, (s) => { s.loading.parcial = false; })
            .addCase(getProyectosRendimientoData.pending, (s) => { s.loading.rendimiento = true; })
            .addCase(getProyectosRendimientoData.fulfilled, (s, a) => { s.loading.rendimiento = false; s.rendimiento = a.payload; })
            .addCase(getProyectosRendimientoData.rejected, (s) => { s.loading.rendimiento = false; });
    }
});

export default DashboardProyectosSlice.reducer;
